import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';
import { useRouteAccessList } from '@hooks';

const PublicReportsRoutes = ({ t ,alert}) => {

    const [access, setAccess] = useState([]);

    useRouteAccessList((res) => {
        setAccess(res.data.route_name);
    });

    const ViewPublicReports = loadable(() => import('./ViewPublicReports'), {
        fallback: <Loader />
    });
    const SignInOffReport = loadable(() => import('./SignInOffReport'), {
        fallback: <Loader />
    });
    const SignInOffReportInactiveUser = loadable(() => import('./SignInOffReportInactiveUser'), {
        fallback: <Loader />
    });
    const LoggedHoursReport = loadable(() => import('./LoggedHoursReport'), {
        fallback: <Loader />
    });

    return (
        <Routes>
            <Route index exact path="/view" element={<ViewPublicReports t={t} access={access} alert={alert} />} />
            <Route path="/sign-in-out" element={<SignInOffReport t={t} access={access} alert={alert} />} />
            <Route path="/log-hrs-report" element={<LoggedHoursReport t={t} access={access} alert={alert} />} />
            <Route index exact path="/sign-in-out/inactive-user" element={<SignInOffReportInactiveUser t={t} access={access} alert={alert} />} />
            <Route path="*" element={<Navigate replace to="/404" />} />
        </Routes>
    );
};

export default PublicReportsRoutes;
